import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Skeleton from '@material-ui/lab/Skeleton';
import { propFunc, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { useArrayWithIndex } from '../../../../../../../helpers/use/useArray';
import FolderTableHead from './FolderTableHead';
const FolderTableSkeleton = (props) => {
    const { onClickSort, order, sort } = props;
    const skeletons = useArrayWithIndex(3);
    return (_jsxs("table", Object.assign({ className: 'mypage_slide_table' }, { children: [_jsx(FolderTableHead, { onClickSort: onClickSort, order: order, sort: sort }), _jsx("tbody", { children: _jsx("tr", Object.assign({ className: 'data_row row' }, { children: skeletons.map(({ index }) => (_jsx("td", Object.assign({ className: 'col' }, { children: _jsx(Skeleton, { className: 'skeleton', variant: 'rect' }) }), index))) })) })] })));
};
FolderTableSkeleton.propTypes = {
    onClickSort: propFunc().isRequired,
    order: propStr().isRequired,
    sort: propStr().isRequired,
};
export default FolderTableSkeleton;
